import apiFetch from '../../apiFetch'

export default function (token, townId) {
  const queryParamsArray = [
    `stateId=${townId}`
  ]
  const queryParams = queryParamsArray.reduce(
    (result, query, idx) => result + (query ? (result ? `&${query}` : `?${query}`) : '')
    , ''
  )
  return apiFetch({ endPoint: `Entity/GetAllColonies${queryParams}`, method: 'GET', token: token })
}
